import React, { Component } from 'react';
import LogoHeader from '../../img/logoyaloverde.png.png';
import LogoHeaderDesk from '../../img/logo-yalo-horizontal.png';
import VivoLogo from '../../img/logo_vivo2x.png';
import { redirectToStore } from '../../utils/stores';
import './style.scss';
import HeaderMobile from '../../style/styledComponents/HeaderMobile';
import HeaderDesktop from '../../style/styledComponents/HeaderDesktop';
import LogoDesktop from '../../style/styledComponents/LogoDesktop';
import LogoMobile from '../../style/styledComponents/LogoMobile';
import Qualicorp from '../../img/logo_qualicorpSVG.svg';
import Whatsapp from '../../img/logo-whatsapp.png';
import DrConsulta from '../../img/logo-drc-white1.png';
import Vivoavulso from '../../img/logo-vivoavulso.png';
import Ifood from '../../img/ifood_logo.png';
import cartaoDrc from '../../img/cartaoDrc_logo_white.png';

class Header extends Component {
	render() {
		let whatsapp = true;

		let { loja } = this.props.match.params;

		if (
			loja === 'qualicorp' ||
			loja === 'epay' ||
			loja === 'ifood' ||
			loja === 'allya'
		) {
			whatsapp = false;
		}

		let partnerWhatsappMobile;
		let partnerWhatsapp = '';
		if (whatsapp) {
			partnerWhatsapp = (
				<div>
					<span>contato@yalo.com.br</span>
				</div>
			);

			partnerWhatsappMobile = (
				<div>
					<span>contato@yalo.com.br</span>
				</div>
			);
		}

		let partnerLogo = '';
		if (!whatsapp) {
			partnerLogo = (
				<div>
					<img src={Ifood} alt='' width={121} />
				</div>
			);
		}

		if (loja === 'allya') {
			partnerLogo = null
		}

		const logos = {
			bancointer: VivoLogo,
			default: LogoHeaderDesk,
			qualicorp: Qualicorp,
			vivoavulso: Vivoavulso,
			drconsulta: DrConsulta,
			cmdrconsulta: DrConsulta,
			ifood: cartaoDrc,
			allya: cartaoDrc
		};

		const logosMobile = {
			bancointer: VivoLogo,
			default: LogoHeaderDesk,
			qualicorp: Qualicorp,
			vivoavulso: Vivoavulso,
			drconsulta: DrConsulta,
			cmdrconsulta: DrConsulta,
			ifood: cartaoDrc,
			allya: cartaoDrc
		};

		const pathArray = window.location.pathname.split('/');

		return (
			<div>
				<HeaderMobile className='visible-xs visible-sm'>
					<HeaderMobile className='header-bar'>
						<a onClick={() => redirectToStore()}>
							<LogoMobile
								src={
									logosMobile[pathArray[2]] ||
									logosMobile.default ||
									logosMobile.qualicorp ||
									logosMobile.vivoavulso ||
									logosMobile.drconsulta ||
									logosMobile.cmdrconsulta ||
									logosMobile.ifood
								}
								alt=''
								className='headerLogo'
							/>
						</a>
						<div className='partners'>{partnerWhatsappMobile}</div>
					</HeaderMobile>
				</HeaderMobile>
				<HeaderDesktop className=' visible-md visible-lg'>
					<HeaderDesktop className='header-bar'>
						<a onClick={() => redirectToStore()}>
							<LogoDesktop
								src={
									logos[pathArray[2]] ||
									logos.default ||
									logos.qualicorp ||
									logos.vivoavulso ||
									logos.drconsulta ||
									logosMobile.cmdrconsulta ||
									logos.ifood
								}
								alt=''
								className='headerLogo'
							/>
						</a>
						<div className='partners'>
							{partnerLogo}
							{partnerWhatsapp}
						</div>
					</HeaderDesktop>
				</HeaderDesktop>
			</div>
		);
	}
}

export default Header;
